import React from 'react';
import { findNodePath, setNodes } from '@udecode/plate-common';
import clsx from 'clsx';
import { useReadOnly } from 'slate-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './element-checkbox.scss';

const DEFAULT_CHECKBOX_SIZE = 12;

const getChildStyle = (children) => {
  // Extract styles applied to child if only one child
  // So it can apply to the list item as well. Multiple
  // children means mixed styles which can be ambiguous
  // on how to style the list item.
  if (children.length === 1) {
    // Only concerned about changing size of the checkbxo
    // for now. Update this if other styles should apply.
    const { fontSize } = children[0];
    return { fontSize };
  }

  return {};
};

export const TodoListElement = (
  props,
) => {
  const { attributes, children, nodeProps, element, editor, style: _style } = props;

  const readOnly = useReadOnly();

  const { checked, children: todoChildren } = element;

  const { fontSize } = getChildStyle(todoChildren);

  const style = fontSize ? {
    height: fontSize,
    width: fontSize,
    ..._style,
  } : {
    height: `${DEFAULT_CHECKBOX_SIZE}px`,
    width: `${DEFAULT_CHECKBOX_SIZE}px`,
    ..._style,
  };

  return (
    <div
      {...attributes}
      className={clsx(
        'slate-todo',
      )}
    >
      <div
        contentEditable={false}
        className={clsx(
          'slate-todo__checkbox-wrapper',
          checked && 'slate-todo__checkbox-wrapper--checked',
        )}
        style={style}
      >
        <input
          data-testid="TodoListElementCheckbox"
          type="checkbox"
          checked={!!checked}
          onChange={(e) => {
            if (readOnly) return;
            const path = findNodePath(editor, element);
            if (!path) return;

            setNodes(
              editor,
              { checked: e.target.checked },
              {
                at: path,
              },
            );
          }}
          {...nodeProps}
        />
        <label
          className={clsx(
            checked ? 'slate-todo__checkbox--checked' : 'slate-todo__checkbox',
          )}
          onClick={() => {
            const newState = !checked;
            const path = findNodePath(editor, element);
            const newProperties = {
              checked: newState,
            };
            setNodes(editor, newProperties, { at: path });
          }}
        >
          <FontAwesomeIcon icon={['fal', 'check']}/>
        </label>
      </div>
      <label
        contentEditable={!readOnly}
        suppressContentEditableWarning
      >
        {children}
      </label>
    </div>
  );
};

export const SerializedTodoElement = (props) => {
  const { children, element, attributes, style: _style } = props;
  const { checked } = element;

  const { children: todoChildren } = element;

  const { fontSize } = getChildStyle(todoChildren);

  const style = fontSize ? {
    height: fontSize,
    width: fontSize,
    ..._style,
  } : _style;


  return (
    <div
      {...attributes}
      className={clsx(
        'slate-todo',
      )}
    >
      <div
        className={clsx(
          'slate-todo__checkbox-wrapper',
          checked && 'slate-todo__checkbox-wrapper--checked',
        )}
        style={style}
      >
        {/* TODO: The backend sanitizes input. Need to evaluate if allowing input elements
            within the sanitizer has risk
        <input
          type="checkbox"
          checked={!!checked}
          readOnly
        />
        */}
        <div
          className={clsx(
            checked ? 'slate-todo__checkbox--checked' : 'slate-todo__checkbox',
          )}
        >
          <span
            className="slate-todo__check-icon"
            style={{ fontSize }}
          >
            {/* eslint-disable */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#ffffff" d="M413.5 92L133.5 372l-99-99c-4.7-4.7-12.3-4.7-17 0L6.2 284.3c-4.7 4.7-4.7 12.3 0 17l118.8 118.8c4.7 4.7 12.3 4.7 17 0l299.8-299.8c4.7-4.7 4.7-12.3 0-17l-11.3-11.3c-4.7-4.7-12.3-4.7-17 0z"/></svg>
            {/* eslint-enable */}
          </span>
        </div>
      </div>
      <div className="slate-todo__pseudo-label">
        {children}
      </div>
    </div>
  );
};
